<template>
  <div>
    <el-button @click="getImgCode">购买</el-button>
    <p>dfsffsfd</p>
    <div ref="qrcode"></div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import {
  getOrder,
  getImgCode
} from "@/api/api"
export default {
  name: "Buy",
  data () {
    return {
      // imgcode: 'weixin://wxpay/bizpayurl?pr=sODcWp7zz'
      link: '',
      orderId: ''
    }

  },
  methods: {
    getImgCode () {
      let orderparam = {
        rankId: 1,
        total: 6,
        realTotal: 0.01
      }
      getOrder(orderparam).then((d) => {
        console.log(d, 'd')
        this.orderId = d.orderId
        if (d.code == 200) {
          getImgCode({ orderId: d.orderId }).then((dd) => {
            // this.link = "weixin://wxpay/bizpayurl?pr=sODcWp7zz"
            this.link = dd.prepay
            this.qrcode(200, 210, this.link, 'canvas')
          })


        }
      })

    },
    qrcode (qWidth, qHeight, qText, qRender) {
      let el = this.$refs.qrcode
      new QRCode(el, {
        width: qWidth,
        height: qHeight,
        text: qText,
        render: qRender
      })
    },
  }

}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/view/buy.vue